import { useStaticQuery, graphql } from 'gatsby';

const useResearchAreas = () => {
  const data = useStaticQuery(graphql`
    query ResearchAreasQuery {
      research_area: allNodePage(
          filter: {
            status: {eq: true},
            promote: {eq: true}
          }, 
          sort: {created: DESC}
        ) {
        edges {
          node {
            ...BasicPageCard
          }
        }
      }
    }
  `);
  
  return data;
};

export default useResearchAreas;